import React from 'react';
import { Avatar, Box } from '@mui/material';
import { StyledFrameImg, CommonAvatarStyled } from './index.style';

const CommonAvatar = ({
  avatar,
  badgeIcon,
  size,
  styleBadgeIcon,
  className,
  frameImageUrl,
}) => (
  <CommonAvatarStyled className={className} size={size}>
    <Avatar src={avatar} alt="avatar" />
    {frameImageUrl && (
      <StyledFrameImg
        src={frameImageUrl}
        alt="badge"
        width={size}
        height={size}
        transform="scale(1.4)"
      />
    )}
    {badgeIcon && !frameImageUrl && (
      <Box sx={styleBadgeIcon} className="badge-icon">
        {badgeIcon}
      </Box>
    )}
  </CommonAvatarStyled>
);

export default CommonAvatar;
